// extracted by mini-css-extract-plugin
module.exports = {"contentLayout":"LandingCarousel_contentLayout__3E2aK","welcomeSvg":"LandingCarousel_welcomeSvg__pTAfA"};